/**
 * 商品列表。没有分类 Tab，也没有切换箭头。
 * 电脑端一行 3 个，移动端一行 2 个，由页面里的 CSS 网格控制。
 * 标题、描述、双端图片和 handle 来自页面里的 JSON。
 * 价格、链接、变体、库存和 Klarna 金额按 handle 向店铺商品补齐。
 */
(function () {
	function initGfpDeal (root) {
		if (!root || root.dataset.gfpInited === 'true') return;

	var cfgEl = root.querySelector('[data-gfp-config]');
	if (!cfgEl) return;
	var cfg;
	try {
	  cfg = JSON.parse(cfgEl.textContent);
	} catch (err) {
	  console.error('[gfp-deal] JSON 配置无法解析', err);
			return;
	}

	var slidesEl = root.querySelector('[data-gfp-slides]');
	var learnLabel = cfg.learn_label || 'Learn more';
	var cartLabel = cfg.cart_label || 'Add to Cart';
	var cardsReady = false;

	/* 金额按主题货币格式输出 */
	function formatMoney(cents) {
	  var themeObj = window.theme || {};
	  if (themeObj.Currency && typeof themeObj.Currency.formatMoney === 'function') {
	    var format = themeObj.settings && themeObj.settings.moneyFormat ? themeObj.settings.moneyFormat : '';
	    var text = themeObj.Currency.formatMoney(cents, format);
	    if (text) return text;
	  }
	  if (cents == null || cents === '') return '';
	  return (Number(cents) / 100).toFixed(2);
	}

	/* 优先可售变体，没有可售的就用第一个 */
	function pickVariant(product) {
	  if (!product || !product.variants || !product.variants.length) return null;
	  for (var i = 0; i < product.variants.length; i++) {
	    if (product.variants[i].available) return product.variants[i];
	  }
	  return product.variants[0];
	}

	/* 按 handle 只补价格、链接、变体、库存和 Klarna 金额。标题、描述、双端图片用手填的值 */
	function fillFromProduct(item, product) {
	  var variant = pickVariant(product);
	  var price = variant && variant.price != null ? variant.price : product.price;
	  var compare = variant && variant.compare_at_price != null ? variant.compare_at_price : product.compare_at_price;
	  item.has_product = true;
	  item.available = !!(variant && variant.available);
	  item.variant_id = variant ? variant.id : 0;
	  item.price_cents = price || 0;
	  item.price_html = formatMoney(item.price_cents);
	  item.compare_html = compare && Number(compare) > Number(item.price_cents) ? formatMoney(compare) : '';
	  item.url = product.url || ('/products/' + encodeURIComponent(product.handle || item.handle));
	}

	function loadProduct(handle) {
	  return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
	    .then(function (res) {
	      if (!res.ok) throw new Error('product');
	      return res.json();
	    })
	    .catch(function () {
	      return null;
	    });
	}

	function el(tag, className, text) {
	  var node = document.createElement(tag);
	  if (className) node.className = className;
	  if (text) node.textContent = text;
	  return node;
	}

	/* 一张商品卡：图、标题、描述、价格、Klarna、加购和 Learn more */
	function buildCard(item) {
	  var slide = el('div', 'swiper-slide');
	  var card = el('article', 'gfp-card');
	  var href = item.link || item.url || '';
	  var title = item.title || '';
	  var deskImg = item.image || '';
	  var mobImg = item.image_mobile || deskImg;

	  var media = href ? el('a', 'gfp-card__media') : el('div', 'gfp-card__media');
	  if (href) {
	    media.href = href;
	    media.setAttribute('aria-label', title);
	  }
	  if (deskImg || mobImg) {
	    if (deskImg) {
	      var desk = el('img', mobImg && mobImg !== deskImg ? 'gfp-card__img--desktop' : 'gfp-card__img--desktop gfp-card__img--mobile');
	      desk.src = deskImg;
	      desk.alt = title;
	      media.appendChild(desk);
	    }
	    if (mobImg && mobImg !== deskImg) {
	      var mob = el('img', 'gfp-card__img--mobile');
	      mob.src = mobImg;
	      mob.alt = title;
	      media.appendChild(mob);
	    }
	  } else {
	    var placeholder = el('span', 'gfp-card__placeholder');
	    placeholder.setAttribute('aria-hidden', 'true');
	    placeholder.innerHTML = '<svg viewBox="0 0 80 80" fill="none"><rect x="8" y="18" width="64" height="44" rx="4" stroke="currentColor" stroke-width="2"/><path d="M8 50l16-14 14 12 10-8 24 18" stroke="currentColor" stroke-width="2"/></svg>';
	    media.appendChild(placeholder);
	  }
	  card.appendChild(media);

	  var body = el('div', 'gfp-card__body');
	  if (title) {
	    var name = el('h3', 'gfp-card__name');
	    if (href) {
	      var nameLink = el('a', '', title);
	      nameLink.href = href;
	      name.appendChild(nameLink);
	    } else {
	      name.textContent = title;
	    }
	    body.appendChild(name);
	  }
	  if (item.description) body.appendChild(el('p', 'gfp-card__type', item.description));

	  if (item.price_html || item.compare_html) {
	    var prices = el('div', 'gfp-card__price-block');
	    if (item.price_html) {
	      var price = el('p', 'gfp-card__price');
	      price.innerHTML = item.price_html;
	      prices.appendChild(price);
	    }
	    if (item.compare_html) {
	      var compare = el('p', 'gfp-card__compare');
	      compare.innerHTML = item.compare_html;
	      prices.appendChild(compare);
	    }
	    body.appendChild(prices);
	  }

	  if (cfg.show_financing && item.has_product && item.price_cents) {
	    var financing = el('div', 'gfp-card__financing');
	    financing.setAttribute('data-gfp-financing-host', '');
	    var placement = document.createElement('klarna-placement');
	    placement.setAttribute('data-key', 'credit-promotion-auto-size');
	    placement.setAttribute('data-locale', cfg.klarna_locale || 'en-US');
	    placement.setAttribute('data-purchase-amount', String(item.price_cents));
	    financing.appendChild(placement);
	    body.appendChild(financing);
	  }

	  var actions = el('div', 'gfp-card__actions');
	  if (item.has_product && item.available && item.variant_id) {
	    var cartBtn = el('button', 'gfp-card__btn gfp-card__btn--cart', cartLabel);
	    cartBtn.type = 'button';
	    cartBtn.setAttribute('data-gfp-atc', '');
	    cartBtn.setAttribute('data-gfp-variant-id', String(item.variant_id));
	    actions.appendChild(cartBtn);
	  } else if (item.has_product && item.variant_id) {
	    var sold = el('button', 'gfp-card__btn gfp-card__btn--cart', cfg.sold_out || 'Sold out');
	    sold.type = 'button';
	    sold.disabled = true;
	    actions.appendChild(sold);
	  } else if (href) {
	    var cartLink = el('a', 'gfp-card__btn gfp-card__btn--cart', cartLabel);
	    cartLink.href = href;
	    actions.appendChild(cartLink);
	  } else {
	    var cartOff = el('button', 'gfp-card__btn gfp-card__btn--cart', cartLabel);
	    cartOff.type = 'button';
	    cartOff.disabled = true;
	    actions.appendChild(cartOff);
	  }
	  if (href) {
	    var learn = el('a', 'gfp-card__btn gfp-card__btn--learn', learnLabel);
	    learn.href = href;
	    actions.appendChild(learn);
	  } else {
	    actions.appendChild(el('span', 'gfp-card__btn gfp-card__btn--learn', learnLabel));
	  }
	  body.appendChild(actions);
	  card.appendChild(body);
	  slide.appendChild(card);
	  return slide;
	}

	function buildMore(more) {
	  if (!more || !more.enabled) return null;
	  var slide = el('div', 'swiper-slide');
	  var card = more.url ? el('a', 'gfp-more-card') : el('div', 'gfp-more-card');
	  if (more.url) card.href = more.url;
	  var media = el('div', 'gfp-more-card__media');
	  var imgUrl = more.image || more.image_mobile || '';
	  if (imgUrl) {
	    var img = el('img');
	    img.src = imgUrl;
	    img.alt = more.title || '';
	    media.appendChild(img);
	  }
	  media.appendChild(el('span', 'gfp-more-card__overlay'));
	  card.appendChild(media);
	  var content = el('div', 'gfp-more-card__content');
	  if (more.title) content.appendChild(el('p', 'gfp-more-card__title', more.title));
	  if (more.subtitle) content.appendChild(el('p', 'gfp-more-card__subtitle', more.subtitle));
	  content.appendChild(el('span', 'gfp-more-card__btn', more.button || learnLabel));
	  card.appendChild(content);
	  slide.appendChild(card);
	  return slide;
	}

	function renderCards() {
	  slidesEl.innerHTML = '';
	  (cfg.products || []).forEach(function (item) {
	    if (!item.handle && !item.title && !item.image) return;
	    slidesEl.appendChild(buildCard(item));
	  });
	  var moreSlide = buildMore(cfg.more);
	  if (moreSlide) slidesEl.appendChild(moreSlide);
	  cardsReady = true;
	  boot();
	}

	/* 有 handle 的卡片先补全商品数据，再画出来 */
	Promise.all((cfg.products || []).map(function (item) {
	  if (!item.handle) return Promise.resolve(item);
	  return loadProduct(item.handle).then(function (product) {
	    if (product) fillFromProduct(item, product);
	    return item;
	  });
	})).then(renderCards);

	/* Klarna 文案画在 shadow 里，外部样式去不掉它的 padding 和边框 */
	var KLARNA_SHADOW_CSS = [
	  '.container, .container.auto-size, [part="osm-container"], [part="osm-message"], [part="osm-cta"] {',
	  'margin: 0 !important;',
	  'padding: 0 !important;',
	  'border: none !important;',
	  'box-shadow: none !important;',
	  'background: transparent !important;',
	  'color: #A3A3AD !important;',
	  'font-family: Poppins-Regular, Poppins, sans-serif !important;',
	  'font-size: 12px !important;',
	  'font-style: normal !important;',
	  'font-weight: 400 !important;',
	  'line-height: 16px !important;',
	  '}',
	  '.container *, .container.auto-size * {',
	  'padding: 0 !important;',
	  'border: none !important;',
	  'box-shadow: none !important;',
	  'color: #A3A3AD !important;',
	  'font-family: Poppins-Regular, Poppins, sans-serif !important;',
	  'font-size: 12px !important;',
	  'font-style: normal !important;',
	  'font-weight: 400 !important;',
	  'line-height: 16px !important;',
	  '}',
	  '/* Check purchase power 是链接，去掉下划线 */',
	  '.container a, .container.auto-size a, [part="osm-cta"], [part="osm-cta"] * {',
	  'text-decoration: none !important;',
	  'text-decoration-line: none !important;',
	  'border-bottom: none !important;',
	  '}',
	  '/* 只加粗 Klarna 这几个字母，旁边的句子仍是 Regular */',
	  '.container [data-deal-klarna-word], .container.auto-size [data-deal-klarna-word], [part="osm-logo"] {',
	  'color: #A3A3AD !important;',
	  'font-family: Poppins-SemiBold, Poppins, sans-serif !important;',
	  'font-size: 12px !important;',
	  'font-style: normal !important;',
	  'font-weight: 600 !important;',
	  'line-height: 16px !important;',
	  '}'
	].join('');

	/* 把文案里的 Klarna 包一层，方便单独改成 SemiBold。重复执行时不再包第二次 */
	function emphasizeKlarnaWord(shadow) {
	  var walker = document.createTreeWalker(shadow, NodeFilter.SHOW_TEXT, null);
	  var textNodes = [];
	  var current;
	  while ((current = walker.nextNode())) textNodes.push(current);
	  for (var i = 0; i < textNodes.length; i++) {
	    var textNode = textNodes[i];
	    var parent = textNode.parentElement;
	    if (!parent || parent.closest('[data-deal-klarna-word]')) continue;
	    if ((parent.tagName || '').toLowerCase() === 'style') continue;
	    var value = textNode.nodeValue;
	    if (!value || value.indexOf('Klarna') === -1) continue;
	    var frag = document.createDocumentFragment();
	    var parts = value.split('Klarna');
	    for (var p = 0; p < parts.length; p++) {
	      if (parts[p]) frag.appendChild(document.createTextNode(parts[p]));
	      if (p < parts.length - 1) {
	        var word = document.createElement('span');
	        word.setAttribute('data-deal-klarna-word', 'true');
	        word.textContent = 'Klarna';
	        frag.appendChild(word);
	      }
	    }
	    textNode.parentNode.replaceChild(frag, textNode);
	  }
	}

	/* 官方样式后注入时，把覆盖样式重新挂到 shadow 末尾 */
	function paintKlarnaShadows() {
	  var placements = root.querySelectorAll('klarna-placement');
	  for (var i = 0; i < placements.length; i++) {
	    var shadow = placements[i].shadowRoot;
	    if (!shadow) continue;
	    emphasizeKlarnaWord(shadow);
	    var styleEl = shadow.querySelector('style[data-deal-klarna]');
	    if (!styleEl) {
	      styleEl = document.createElement('style');
	      styleEl.setAttribute('data-deal-klarna', 'true');
	    }
	    styleEl.textContent = KLARNA_SHADOW_CSS;
	    shadow.appendChild(styleEl);
	  }
	}

	function refreshKlarna() {
	  if (window.Klarna && window.Klarna.OnsiteMessaging && typeof window.Klarna.OnsiteMessaging.refresh === 'function') {
	    window.Klarna.OnsiteMessaging.refresh();
	  }
	  paintKlarnaShadows();
	  var tries = 0;
	  var timer = setInterval(function () {
	    tries += 1;
	    paintKlarnaShadows();
	    if (tries > 20) clearInterval(timer);
	  }, 300);
	}

	/* 加购走主题购物车抽屉，和原组件同一套请求 */
	root.addEventListener('click', function (e) {
	  var btn = e.target.closest('[data-gfp-atc]');
	  if (!btn || !root.contains(btn)) return;
	  e.preventDefault();
	  if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
	  var variantId = btn.getAttribute('data-gfp-variant-id');
	  if (!variantId) return;

	  var themeObj = window.theme || {};
	  var cartType = themeObj.settings ? themeObj.settings.cartType : '';
	  if (document.body.classList.contains('template-cart') || cartType === 'page') {
	    var addBase = (themeObj.routes && themeObj.routes.cart_add_url) ? themeObj.routes.cart_add_url : '/cart/add';
	    window.location.href = addBase + '?id=' + encodeURIComponent(variantId) + '&quantity=1';
			return;
		}

	  btn.setAttribute('aria-busy', 'true');
	  var cartDrawer = document.querySelector('cart-drawer');
	  if (cartDrawer && typeof cartDrawer.show === 'function') cartDrawer.show(btn);

	  var sectionsToBundle = [];
	  document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
	    bubbles: true,
	    detail: { sections: sectionsToBundle }
	  }));

	  var body = JSON.stringify({
	    items: [{ id: Number(variantId), quantity: 1 }],
	    sections: sectionsToBundle,
	    sections_url: window.location.pathname
	  });
	  var cartAddUrl = (themeObj.routes && themeObj.routes.cart_add_url) ? themeObj.routes.cart_add_url : '/cart/add.js';
	  var addConfig = (themeObj.utils && themeObj.utils.fetchConfig)
	    ? themeObj.utils.fetchConfig('javascript')
	    : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
	  addConfig.body = body;

	  fetch(cartAddUrl, addConfig)
	    .then(function (response) { return response.json(); })
	    .then(function (parsedState) {
	      if (parsedState.status) throw new Error(parsedState.description || 'Add to cart failed');
	      var cartUrl = (themeObj.routes && themeObj.routes.cart_url) ? themeObj.routes.cart_url : '/cart.js';
	      var cartConfig = (themeObj.utils && themeObj.utils.fetchConfig)
	        ? themeObj.utils.fetchConfig('json', 'GET')
	        : { headers: { Accept: 'application/json' } };
	      return fetch(cartUrl, cartConfig)
	        .then(function (res) { return res.json(); })
	        .then(function (cartJson) {
	          cartJson.sections = parsedState.sections;
	          if (themeObj.pubsub && themeObj.pubsub.PUB_SUB_EVENTS) {
	            themeObj.pubsub.publish(themeObj.pubsub.PUB_SUB_EVENTS.cartUpdate, {
	              source: 'gfp-deal',
	              productVariantId: variantId,
	              cart: cartJson
	            });
	          }
	          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));
	        });
	    })
	    .catch(function (error) {
	      console.error('[gfp-deal] add to cart failed', error);
	    })
	    .finally(function () {
	      btn.removeAttribute('aria-busy');
	    });
	});

	/* 卡片画完后刷新 Klarna。排列由 CSS 网格负责，这里不再初始化轮播 */
	function boot() {
	  if (!cardsReady) return;
	  refreshKlarna();
	}

	root.dataset.gfpInited = 'true';
	}

	function bootGfpDeals () {
		var roots = document.querySelectorAll('[data-gfp-root]');
		for (var i = 0; i < roots.length; i++) initGfpDeal(roots[i]);
	}

	document.addEventListener('swiper:ready', bootGfpDeals);
	window.addEventListener('swiper:ready', bootGfpDeals);
	window.addEventListener('load', bootGfpDeals);
	document.addEventListener('shopify:section:load', function (event) {
		if (!event.target || !event.target.querySelectorAll) return;
		var roots = event.target.querySelectorAll('[data-gfp-root]');
		for (var i = 0; i < roots.length; i++) {
			delete roots[i].dataset.gfpInited;
			initGfpDeal(roots[i]);
		}
	});
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', bootGfpDeals);
	}
	bootGfpDeals();
})();

/**
 * 移动端系列 tab。标题去掉末尾的 series 当作选项，点击滚到对应系列。
 * 电脑端这条导航是隐藏的，脚本仍可绑定，不影响桌面排版。
 */
(function () {
	function seriesLabel(seriesEl) {
		var text = (seriesEl.textContent || '').replace(/\s+/g, ' ').trim();
		return text.replace(/\s+series$/i, '');
	}

	function navOffset() {
		var raw = getComputedStyle(document.documentElement).getPropertyValue('--sbc-nav-offset').trim();
		var px = parseFloat(raw);
		if (!isFinite(px)) px = 48;
		var header = document.querySelector('.header-section');
		var hidden = document.documentElement.classList.contains('nav-away')
			|| (header && header.classList.contains('header-hidden'));
		return hidden ? 0 : px;
	}

	/* 滚到导航下缘就固定，滚出当前分组后还原 */
	function bindSeriesSticky(nav) {
		var hold = nav.parentElement;
		var group = nav.closest('.pgt-pick__group');
		if (!hold || !group || hold.dataset.gfpStickyBound === 'true') return;
		hold.dataset.gfpStickyBound = 'true';

		function unstick() {
			nav.classList.remove('is-stuck');
			nav.style.top = '';
			hold.style.height = '';
		}

		function update() {
			if (window.innerWidth > 1024) {
				unstick();
				return;
			}
			var offset = navOffset();
			var holdTop = hold.getBoundingClientRect().top;
			var groupBottom = group.getBoundingClientRect().bottom;
			var height = nav.offsetHeight;
			/* 多 2px，避免滚到贴齐时被亚像素判断成还没吸顶 */
			var shouldStick = holdTop <= offset + 2 && groupBottom > offset + height;
			if (!shouldStick) {
				unstick();
				return;
			}
			if (!nav.classList.contains('is-stuck')) {
				hold.style.height = height + 'px';
				nav.classList.add('is-stuck');
			}
			nav.style.top = offset + 'px';
		}

		window.addEventListener('scroll', update, { passive: true });
		window.addEventListener('resize', update);
		update();
	}

	function initSeriesTabs(nav) {
		if (!nav || nav.dataset.gfpTabsInited === 'true') return;
		var group = nav.closest('.pgt-pick__group') || nav.parentElement;
		if (!group) return;
		var deals = group.querySelectorAll('.gfp-deal');
		var scroller = nav.querySelector('[data-gfp-tabs-scroller]');
		if (!scroller || !deals.length) return;
		nav.dataset.gfpTabsInited = 'true';
		scroller.innerHTML = '';

		var tabs = [];
		var tabDeals = [];

		var prev = nav.querySelector('[data-gfp-tabs-prev]');
		var next = nav.querySelector('[data-gfp-tabs-next]');

		/* 第一项藏起左箭头和竖线，最后一项藏起右箭头和竖线 */
		function syncArrows(index) {
			if (prev) prev.classList.toggle('is-hidden', index <= 0);
			if (next) next.classList.toggle('is-hidden', index >= tabs.length - 1);
		}

		/* 选中某一项，并滚到对应系列。到头之后不再切换 */
		function selectTab(index) {
			if (index < 0 || index >= tabs.length) return;
			for (var j = 0; j < tabs.length; j++) tabs[j].classList.remove('is-active');
			tabs[index].classList.add('is-active');
			syncArrows(index);
			tabs[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
			/* 第一项上面就是分类条，按系列去滚会停在导航下面一条缝，改成把分类条贴到导航下缘 */
			if (index === 0) {
				var hold = nav.parentElement;
				var delta = hold.getBoundingClientRect().top - navOffset();
				window.scrollBy({ top: delta, behavior: 'smooth' });
				return;
			}
			tabDeals[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
		}

		for (var i = 0; i < deals.length; i++) {
			var series = deals[i].querySelector('.gfp-deal__series');
			if (!series) continue;
			var button = document.createElement('button');
			button.type = 'button';
			button.className = 'gfp-series-tabs__item' + (tabs.length === 0 ? ' is-active' : '');
			button.textContent = seriesLabel(series);
			(function (index) {
				button.addEventListener('click', function () { selectTab(index); });
			})(tabs.length);
			tabs.push(button);
			tabDeals.push(deals[i]);
			scroller.appendChild(button);
		}

		function activeIndex() {
			for (var i = 0; i < tabs.length; i++) {
				if (tabs[i].classList.contains('is-active')) return i;
			}
			return 0;
		}

		/* 左箭头上一个，右箭头下一个。到头就停住 */
		if (prev) prev.addEventListener('click', function () { selectTab(activeIndex() - 1); });
		if (next) next.addEventListener('click', function () { selectTab(activeIndex() + 1); });
		syncArrows(activeIndex());
		bindSeriesSticky(nav);
	}

	function bootSeriesTabs() {
		var navs = document.querySelectorAll('[data-gfp-series-tabs]');
		for (var i = 0; i < navs.length; i++) initSeriesTabs(navs[i]);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', bootSeriesTabs);
	}
	bootSeriesTabs();
	document.addEventListener('shopify:section:load', function (event) {
		if (!event.target || !event.target.querySelectorAll) return;
		var navs = event.target.querySelectorAll('[data-gfp-series-tabs]');
		for (var i = 0; i < navs.length; i++) {
			delete navs[i].dataset.gfpTabsInited;
			initSeriesTabs(navs[i]);
		}
	});
})();

/* 订阅表单：没勾条款就拦住提交，勾上后清掉错误提示 */
(function () {
	function bindSubscribeForm(form) {
		if (!form || form.dataset.gfsBound === 'true') return;
		form.dataset.gfsBound = 'true';
		var consent = form.querySelector('[data-gfs-consent]');
		var consentLabel = form.querySelector('.gfs-consent');
		var consentError = form.querySelector('[data-gfs-consent-error]');

		function setConsentInvalid(invalid) {
			if (consentLabel) consentLabel.classList.toggle('is-invalid', !!invalid);
			if (consentError) consentError.classList.toggle('is-visible', !!invalid);
		}

		if (consent) {
			consent.addEventListener('change', function () {
				if (consent.checked) setConsentInvalid(false);
			});
		}

		form.addEventListener('submit', function (event) {
			if (consent && !consent.checked) {
				event.preventDefault();
				event.stopPropagation();
				setConsentInvalid(true);
				consent.focus();
				return false;
			}
			setConsentInvalid(false);
		});
	}

	function bootSubscribeForms(root) {
		var scope = root && root.querySelectorAll ? root : document;
		var forms = scope.querySelectorAll('.gfs-newsletter-form');
		for (var i = 0; i < forms.length; i++) bindSubscribeForm(forms[i]);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { bootSubscribeForms(document); });
	}
	bootSubscribeForms(document);
	document.addEventListener('shopify:section:load', function (event) {
		bootSubscribeForms(event.target || document);
	});
})();
